// extracted by mini-css-extract-plugin
export default {"wrap":"skin1-module_wrap_Z5hbY","playItem":"skin1-module_playItem_jjc96"};